import { useRouter } from "vue-router";
import { encrypt } from "@/business/shared/commons/encrypt/encryptService";
import { login } from "@/business/auth/application/login";

export function loginUse() {
  const router = useRouter();

  async function authenticate(email: string, password: string): Promise<void> {
    const encryptPassword = await encrypt(password);
    const route = await login.execute(email, encryptPassword);
    await router.push(route);
  }

  return {
    authenticate,
  };
}
